export enum UserRole {
  OWNER = "OWNER",
  USER = "USER",
}
